import * as React from 'react';
import cx from 'classnames';

import { TypographyStyle } from '../../types';
import { Typography } from '../../../components/Typography';

/**
 * The Text Component within a Bar.
 */
export interface IBarTextProps {
  /** Passed down classname. */
  className?: string;
  /** Make the Button small. */
  isSmall?: boolean;
  /** Make this expand fully */
  isFullWidth?: boolean;
  /** Button has a white outline and text, the background color is dependant on parent */
  isReverse?: boolean;
  /** Elements Text. */
  text: string;
}

export const BarText: React.FC<IBarTextProps> = ({
  className,
  isFullWidth,
  isReverse = false,
  text,
}) => {
  const combinedClass = cx({
    'panda-bar-item': true,
    'flex-align': true,
    'flex-1': isFullWidth,
    'text-ellipsis': true,
    // Reverse style
    'panda-bar-item-normal': !isReverse,
    'panda-bar-item-reverse': isReverse,
    // Custom classname
    [className || '']: true,
  });

  return (
    <div className={combinedClass}>
      <Typography type={TypographyStyle.P2}>{text}</Typography>
    </div>
  );
};
